import { tailorSchemas } from '../../../tailor'
import { essentials2Fit } from './section-fit'
import { lightings1BaseSchemas } from '../../lightings/lightings-1/builder-schemas'
import { catalogueSchemas } from './sections/catalogue'
import { schema as footerSchema } from './sections/footer/footer.schema'
import { schema as headerSchema } from './sections/header/header.schema'
import { homeSchemas } from './sections/home'
import { purchaseSchemas } from './sections/purchase'

/**
 * Prottoho (essentials-2), the Cares storefront design. It renders the shared section types with its own
 * markup (storefront-nuxt `sections/<type>/themes/essentials-2.vue`) and adds Cares-only home sections; the
 * shared schemas keep stored data portable between themes.
 */
export const essentials2Schemas = tailorSchemas({
  ...lightings1BaseSchemas,
  componentSchemas: {
    ...lightings1BaseSchemas.componentSchemas,
    ...homeSchemas,
    ...catalogueSchemas,
    ...purchaseSchemas,
  },
  headerSchema,
  footerSchema,
}, essentials2Fit)
